import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Store } from '@ngrx/store';
import { of, ReplaySubject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { Selectors, Actions } from 'store/root-reducer';
import { TableNameType, TablePreferenceType } from 'modules/shared/models/table-preference.models';
import { CustomerService } from 'modules/core/services/customer.service';
import { SnackbarService } from 'app/services/snackbar.service';
var PeriodicReviewTableComponent = /** @class */ (function () {
    function PeriodicReviewTableComponent(customersService, snackBar, cdRef, store) {
        this.customersService = customersService;
        this.snackBar = snackBar;
        this.cdRef = cdRef;
        this.store = store;
        this.unsubscribe$ = new ReplaySubject(1);
        // Names should be same as used for sorting on the backend
        this.displayedColumns = ['name', 'risk_rating', 'risk_report_created_at', 'actions'];
        this.pageSizeOptions = [5, 10, 15];
        this.currentPage = 0;
        this.preferredPeriodicReviewTablePageSize = this.pageSizeOptions[0];
        this.isLoading = false;
        this.periodicReviewDataSource = new MatTableDataSource([]);
        this.isActiveTableTab = 'context';
    }
    Object.defineProperty(PeriodicReviewTableComponent.prototype, "sort", {
        set: function (sort) {
            this.periodicReviewDataSource.sort = sort;
        },
        enumerable: true,
        configurable: true
    });
    PeriodicReviewTableComponent.prototype.ngOnInit = function () {
        this.getPeriodicReviewTablePreference();
    };
    PeriodicReviewTableComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    /**
     * Get table pagination preference from store
     * @method getPeriodicReviewTablePreference
     */
    PeriodicReviewTableComponent.prototype.getPeriodicReviewTablePreference = function () {
        var _this = this;
        this.store.select(Selectors.userPreference.getTablesPreference)
            .pipe(takeUntil(this.unsubscribe$), take(1))
            .subscribe(function (tablesPreference) {
            var tablePreference = tablesPreference[TableNameType.ONGOING_DUE_DILIGENCE_TABLE];
            if (tablePreference) {
                if (tablePreference[TablePreferenceType.PAGE_SIZE]) {
                    _this.preferredPeriodicReviewTablePageSize = tablePreference[TablePreferenceType.PAGE_SIZE];
                }
                if (tablePreference[TablePreferenceType.SORT]) {
                    _this.periodicReviewDataSource.sort.active = tablePreference[TablePreferenceType.SORT].active;
                    _this.periodicReviewDataSource.sort.direction = tablePreference[TablePreferenceType.SORT].direction;
                }
            }
            _this.getPeriodicReviewTableData();
        });
    };
    /**
     * Load list of periodic review
     * @method getPeriodicReviewTableData
     */
    PeriodicReviewTableComponent.prototype.getPeriodicReviewTableData = function () {
        var _this = this;
        this.isLoading = true;
        this.cdRef.detectChanges();
        this.customersService
            .loadPeriodicReview({
            limit: this.preferredPeriodicReviewTablePageSize,
            offset: this.preferredPeriodicReviewTablePageSize * this.currentPage,
            sort: this.currentTableSort,
            name: this.filterPeriodicReviewName
        })
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (res) {
            _this.periodicReviewResults = res.results.map(function (periodicReview) {
                var output = Object.assign({}, periodicReview);
                output.riskReportCreatedAt = output.riskReportCreatedAt.replace(/\s/g, 'T');
                return output;
            });
            _this.periodicReviewDataSourceLength = of(res.count);
            _this.periodicReviewDataSource.data = _this.periodicReviewResults;
            _this.isLoading = false;
            _this.cdRef.detectChanges();
        }, function (error) {
            _this.snackBar.error('Error: Failed to load list of periodic review');
            _this.isLoading = false;
            _this.cdRef.detectChanges();
        });
    };
    /**
     * Pagination event handler
     * @method tablePaginationChangeHandler
     */
    PeriodicReviewTableComponent.prototype.tablePaginationChangeHandler = function (event) {
        if (event.pageSize !== this.preferredPeriodicReviewTablePageSize) {
            this.store.dispatch(new Actions.userPreference.SetPaginationPreference({ tableName: TableNameType.ONGOING_DUE_DILIGENCE_TABLE, pageSize: event.pageSize }));
            this.preferredPeriodicReviewTablePageSize = event.pageSize;
        }
        this.currentPage = event.pageIndex;
        this.getPeriodicReviewTableData();
    };
    /**
     * Add sort information to preference store
     * @method tableSortChangeHandler
     */
    PeriodicReviewTableComponent.prototype.tableSortChangeHandler = function (event) {
        var _a;
        this.store.dispatch(new Actions.userPreference.SetSortPreference((_a = {
                tableName: TableNameType.ONGOING_DUE_DILIGENCE_TABLE
            },
            _a[TablePreferenceType.SORT] = {
                active: event.active,
                direction: event.direction
            },
            _a)));
        switch (event.direction) {
            case 'asc':
                this.currentTableSort = "" + event.active;
                break;
            case 'desc':
                this.currentTableSort = "-" + event.active;
                break;
            default:
                this.currentTableSort = undefined;
                break;
        }
        this.getPeriodicReviewTableData();
    };
    /**
     * Apply filter by name for the table
     * @method applyNameFilter
     */
    PeriodicReviewTableComponent.prototype.applyNameFilter = function (filterValue) {
        this.currentPage = 0;
        this.paginator.firstPage();
        this.getPeriodicReviewTableData();
    };
    return PeriodicReviewTableComponent;
}());
export { PeriodicReviewTableComponent };
